
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/common_structures/wallet",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/common_structures/wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/common_structures/wallet"])
      });
    }
  